import React from 'react';

// Simple presentational component extracted from routes/Journal.jsx
// Renders the static "Aims and scope" section. Classes and markup preserved.
export default function AimsAndScope() {
  return (
    <div className="aims-and-scope hidden lg:block mt-[80px]">
      <h2 className="text-[18px] font-bold mb-5 lg:text-[20px] lg:mb-6">
        Aims and scope
      </h2>
      <div className="text-[16px] text-[#6C7687] leading-[150%]">
        Accounting History Review is an international forum for research
        into the history of accounting thought, practice, and
        institutions. Our primary goal is the publication of scholarly
        articles that investigate accounting and its implication in
        diverse social, cultural, and multi-faceted institutional
        contexts across space and time.<br/><br/>
        Accounting History Review is of interest not only to accounting
        historians but also specialists in other disciplinary areas of
        history and management in view of the pervasive and central role
        played by accounting in organisations. This scope is reflected
        in the membership of the journal’s Editorial Board and its
        readership.<br/><br/>
        The journal maintains its reputable position by privileging
        accounting’s past as a worthy subject of inquiry.
        Notwithstanding, the goal is not accounting history that looks
        inwardly to demonstrate accounting’s present-day utility, but a
        history that looks outwardly into contexts with which accounting
        interacts. The scope of the journal explicitly includes research
        which reconsiders accounting’s past from differing and competing
        points of view;
      </div>
    </div>
  );
}
